import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import AOS from 'aos';

import 'slick-carousel';

import OneVideo from 'Modules/module-oneVideoAutoplay';
import OneSocial from 'Modules/module-oneSocial';

"use strict";

var ViewArticle = Backbone.View.extend({

    initialize: function (opts) {
        var self = this;
        self.$content = self.$el;
        self.theBody = $('body');
        self.theHeader = self.theBody.find('header.site-header');
        self.$storySlider = self.$content.find('.story-slider-wrap');
        self.$articleSlider = self.$content.find('.article-slider');
        self.$articleSliderNav = self.$storySlider.find('.slider-nav');
        self.$socialIcons = self.$content.find('.social-sharing');

        self.imageCarousel(self.$content.find('.with-slider'),true);
        self.fullwidthSlider(self.$content.find('.fullwidth-slider'));
        self.initVideo();
        // self.sliders();
        // self.social();
    },
    
    events: {
        'click .share-copy': function (e) {
            self.link = window.location.href;
            link = self.link;
            
            e.preventDefault();
            window.prompt("Copy to clipboard: Ctrl+C, Enter", link);
            // self.seoTools('productEmail');
        },

        // open all hyperlinks in new tab
        'click header a, .rte > div:not(.collection-module) a': function (e) {
            e.preventDefault();
            var el = e.currentTarget || e.target;
            if (el instanceof HTMLAnchorElement) {
                window.open(el.getAttribute('href'), "_blank", "noopener,noreferrer");
            }
        }
    },

    imageCarousel: function(selector,mobileOnly){
        var self = this;
        self.$imageModule = selector;

        if(mobileOnly){
            if(self.isMobile()){

                self.$imageModule.slick({
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 400,
                    slidesToShow: 1,
                    fade: true,
                    centerMode: false,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    variableWidth: false
                });

            }
        }else{
            self.$imageModule.slick({
                dots: true,
                arrows: false,
                infinite: true,
                speed: 400,
                slidesToShow: 1,
                fade: true,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 6000,
                variableWidth: false
            });

        }
        AOS.refresh();
    },

    fullwidthSlider: function(selector){
      var self = this;
      self.$fullwidthSlider = selector;
      const autoplay = selector.attr('data-attr-autoplay');
      const autoplaySpeed = selector.attr('data-attr-speed');
      
      var events = {
          'init .fullwidth-slider': function(e, slick) {
            var $video = $(e.currentTarget).find('.slick-active .slide-video')
            $video.length > 0 && $video.get(0).play();
          },
          'beforeChange .fullwidth-slider': function(e, slick, currentSlide, nextSlide) {
              var $video = $(e.currentTarget).find('.slide-video')
              $video.length > 0 && $video.get(0).pause();
          },
          'afterChange .fullwidth-slider': function(e, slick, currentSlide, nextSlide) {
            var $video = $(e.currentTarget).find('.slide-video')
            $video.length > 0 && $video.get(0).play();
          }
      }

      // Update and delegate adding events
      _.extend(self.events, events);
      self.delegateEvents();

      if (autoplay === "true") {
        self.$fullwidthSlider.slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 400,
          slidesToShow: 1,
          fade: true,
          centerMode: false,
          autoplay: true,
          autoplaySpeed: autoplaySpeed,
          variableWidth: false,
        });
      } else {
        self.$fullwidthSlider.slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 400,
          slidesToShow: 1,
          fade: true,
          centerMode: false,
          autoplay: false,
          variableWidth: false,
        });
      }

      AOS.refresh();
  },

    sliders: function(){
        var self = this;

        var sliderNavPosition = function(){
            var $currentImage = self.$articleSlider.find('.slick-current img');
            var height = $currentImage.outerHeight() + 22;
            self.$articleSliderNav.css('top', height+'px');
        }

        self.$articleSlider.on('init', function(event, slick, currentSlide, nextSlide){
            sliderNavPosition();
        });

        self.$articleSlider = self.$articleSlider.slick({
            prevArrow: self.$storySlider.find('.prev'),
            nextArrow: self.$storySlider.find('.next'),
            adaptiveHeight: true
        });

        self.$articleSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            self.$articleSliderNav.find('.current').text(nextSlide + 1);
            sliderNavPosition();
        });

        $(window).on('resize orientationChange', function(event) {
            console.log("slick resize event");
            sliderNavPosition();
        });

        var events = {
            'click .slider-nav .next': function(e){
                self.$articleSlider.slick("slickNext");
            },
            'click .slider-nav .prev': function(e){
                self.$articleSlider.slick("slickPrev");
            },
            'click .article-slider .slick-slide': function(e){
                var currentIndex = $(e.currentTarget).data('slick-index');
                self.$articleSlider.slick('slickGoTo', currentIndex + 1, false);
            }
        };

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initVideo: function(){
        var self = this;
        self.$videoBoxes = self.$content.find('.video-box');
        OneVideo.init({
            el: self.$videoBoxes,
            startMuted: true,
        });

        if(self.isMobile()){

            // _.each(self.$content.find('.poster-image'), function(posterImgs){
            //     var thePoster = $(posterImgs).attr('data-poster');
            //     if(typeof thePoster !== 'undefined' && thePoster.length){
            //         $(posterImgs).css({ 'background-image': 'url('+ thePoster +')' });
            //     }
            //     thePoster = "";
            // });
        }
    },

    social: function(){
        var self = this;
        var brand = 'White + Warren';
        var description = self.$content.find('.excerpt').text();
        
        self.$socialIcons.hoverIntent({
            over: function(){
                self.$socialIcons.toggleClass('active');
            },
            out: function(){
                self.$socialIcons.toggleClass('active');
            }
            // sensitivity: 100,
            // selector: '.has-dropdown'
        });

        // OneSocial.init({
        //     el: self.$el,
        //     title: self.$content.find('h1').text(),
        //     description: description,
        //     image: function(){
        //         var $image = $('<img>');
        //         if (self.isMobile()) {
        //             $image = self.$content.find('.slick-active img');
        //         } else {
        //             $image = self.$content.find('.ps-active img');
        //         }
        //         return $image.prop('src');
        //     },
        //     pinterestTag: '#' + brand,
        //     twitterTag: '@' + brand,
        // });

    },
    
    isMobile: function () {
        var self = this;
        var w = $(window).width();
        if (w <= ORW.responsiveSizes.medium) {
            return true;
        }
        return false;
    },
    
    isTablet: function () {
        var self = this;
        var w = $(window).width();
        if (w >= ORW.responsiveSizes.medium && w <= ORW.responsiveSizes.large) {
            return true;
        }
        return false;
    },

});

export default ViewArticle;